import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// 1. Import your existing Login/Register components
import Login from "./../Pages/Login";

import "./../Styles/cart.css";
import { API } from "./../../config/api";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
export default function Cart() {
  const navigate = useNavigate();
  const [cartData, setCartData] = useState([]);
  const [user, setUser] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  // 2. Add the same states used in your Navbar
  const [showLogin, setShowLogin] = useState(false);

  /* ================= LOAD CART ================= */
  useEffect(() => {
    const loadUser = () => {
      const loginUser = JSON.parse(sessionStorage.getItem("user"));
      setUser(loginUser);

      if (loginUser) {
        const saved =
          JSON.parse(localStorage.getItem(`cart_${loginUser.id}`)) || [];
        setCartData(saved);
      }
    };

    loadUser();

    // Listen for login/logout events just like Navbar does
    window.addEventListener("userLogin", loadUser);
    window.addEventListener("userLogout", loadUser);

    return () => {
      window.removeEventListener("userLogin", loadUser);
      window.removeEventListener("userLogout", loadUser);
    };
  }, []);

  /* ================= REMOVE LOGIC ================= */
  /* ================= REMOVE LOGIC ================= */
  const removeItem = (id) => {
    const updated = cartData.filter((item) => item.id !== id);
    setCartData(updated);
    if (user) {
      localStorage.setItem(`cart_${user.id}`, JSON.stringify(updated));
      // TRIGGER NAVBAR UPDATE
      window.dispatchEvent(new Event("cartUpdated"));
    }
  };

  const removeAll = () => {
    setCartData([]);
    if (user) {
      localStorage.setItem(`cart_${user.id}`, JSON.stringify([]));
      // TRIGGER NAVBAR UPDATE
      window.dispatchEvent(new Event("cartUpdated"));
    }
  };
  const loadRazorpay = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);

      document.body.appendChild(script);
    });
  };
  /* ================= SEND ORDER ================= */
  const handleSendOrder = async () => {
    if (!user) {
      setShowLogin(true);
      return;
    }

    const loaded = await loadRazorpay();

    if (!loaded) {
      alert("Unable to load Razorpay");
      return;
    }

    const res = await fetch(
      API.BASE_URL + "/payment.php?action=create_cart_order",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          user_id: user.id,

          total_amount: total,

          items: cartData,
        }),
      },
    );

    const order = await res.json();

    if (!order.success) {
      alert(order.message);
      return;
    }

    const options = {
      key: order.key,

      amount: order.amount,

      currency: order.currency,

      order_id: order.order_id,

      name: "Embroidery Bazar",

      description: "Design Purchase",
      notes: {
        app_name: "Embroidery Bazar",
        platform: "Web",
        description: "Design Purchase",
      },

      image: "https://www.embroiderybazar.in/logo.png",

      handler: async function (response) {
        const verify = await fetch(
          API.BASE_URL + "/payment.php?action=verify_cart_payment",
          {
            method: "POST",

            headers: {
              "Content-Type": "application/json",
            },

            body: JSON.stringify({
              razorpay_payment_id: response.razorpay_payment_id,

              razorpay_order_id: response.razorpay_order_id,

              razorpay_signature: response.razorpay_signature,
            }),
          },
        );

        const result = await verify.json();

        if (result.success) {
          localStorage.removeItem(`cart_${user.id}`);

          setCartData([]);

          window.dispatchEvent(new Event("cartUpdated"));

          navigate("/myorders?payment=success");
        } else {
          alert(result.message);

          navigate("/cart?payment=failed");
        }
      },

      prefill: {
        name: order.name,

        email: order.email,

        contact: order.phone,
      },

      theme: {
        color: "#0d6efd",
      },

      modal: {
        ondismiss: async function () {
          await fetch(
            API.BASE_URL + "/payment.php?action=cancel_cart_payment",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                razorpay_order_id: order.order_id,
              }),
            },
          );

          navigate("/cart?payment=cancel");
        },
      },
    };

    const rzp = new window.Razorpay(options);

    rzp.on("payment.failed", function (response) {
      console.log(response.error);

      alert(response.error.description);

      navigate("/cart?payment=failed");
    });

    rzp.open();
  };
  const total = cartData.reduce(
    (sum, item) => sum + Number(item.price || 0),
    0,
  );
  const location = useLocation();
  useEffect(() => {
    if (!user) return;

    const params = new URLSearchParams(location.search);
    const payment = params.get("payment");

    if (payment === "success") {
      localStorage.removeItem(`cart_${user.id}`);
      setCartData([]);

      window.dispatchEvent(new Event("cartUpdated"));
    }
  }, [location.search, user]);
  /* ================= RENDER PLACEHOLDER IF NOT LOGGED IN ================= */
  if (!user) {
    return (
      <div className="container text-center mt-5 py-5 border rounded bg-light shadow-sm">
        <i className="bi bi-cart-x fs-1 text-muted"></i>
        <h4 className="mt-3 fw-bold">Please Login to View Your Cart</h4>
        <p className="text-muted">
          You need to be logged in to manage your items and place orders.
        </p>

        {/* Trigger Pop-up */}

        <div className="d-flex justify-content-center mt-3">
          <button
            className="btn btn-primary px-5 py-2 fw-bold"
            onClick={() => setShowLogin(true)}
          >
            Login Now
          </button>
        </div>

        {/* 3. Include the Pop-up components at the bottom */}
        <Login
          isOpen={showLogin}
          onClose={() => setShowLogin(false)}
          openRegister={() => {
            setShowLogin(false);
            navigate("/register", {
              state: { from: location.pathname },
            });
          }}
        />
      </div>
    );
  }

  /* ================= MOVE TO WISHLIST ================= */

  const moveToWishlist = (item) => {
    let wishlist =
      JSON.parse(localStorage.getItem(`wishlist_${user.id}`)) || [];

    const already = wishlist.find(
      (w) => w.id === item.id && w.type === "design",
    );

    if (!already) {
      wishlist.push({
        ...item,
        type: "design",
      });

      localStorage.setItem(`wishlist_${user.id}`, JSON.stringify(wishlist));
    }

    removeItem(item.id);
  };

  /* ================= TOTAL ================= */

  return (
    <div className="cart-page container-fluid">
      {location.search.includes("payment=success") && (
        <div className="alert alert-success">
          Payment completed successfully.
        </div>
      )}

      {location.search.includes("payment=failed") && (
        <div className="alert alert-danger">
          Your Payment is failed!! , Please Try Again!
        </div>
      )}
      {location.search.includes("payment=cancel") && (
        <div className="alert alert-warning">Payment cancelled by user.</div>
      )}
      <div className="row">
        {/* LEFT SIDE */}

        <div className="col-lg-9">
          <div className="cart-header">
            <div className="cart-left">
              <span>No</span>
              <span>Design ({cartData.length})</span>
            </div>

            <div className="cart-right">
              <span>Total Rs. {total}</span>

              <button className="remove-all" onClick={removeAll}>
                REMOVE ALL
              </button>
            </div>
          </div>

          {/* CART ITEMS */}

          <div className="cart-grid">
            {cartData.map((item, index) => (
              <div className="cart-item" key={item.id}>
                <div className="item-no">{index + 1}</div>

                <div className="cart-img-box">
                  <img
                    src={`${API.BASE_URL}/uploads/Design_seller/${item.user_id}/${item.jpeg_file}`}
                    className="cart-img"
                    alt=""
                    onClick={() =>
                      setPreviewImage(
                        `${API.BASE_URL}/uploads/Design_seller/${item.user_id}/${item.jpeg_file}`,
                      )
                    }
                    style={{ cursor: "zoom-in" }}
                  />
                </div>

                <div className="cart-details">
                  <p>Code : {item.design_code}</p>
                  <p>Area : {item.area}</p>
                  <p>Stitch : {item.stitch}</p>
                  <p>Colour : {item.color}</p>
                </div>

                <div className="cart-price">Rs. {item.price || 0}</div>

                <div className="cart-icons">
                  <button
                    className="icon-btn"
                    onClick={() =>
                      navigate(`/design-details/${item.id}`, { state: item })
                    }
                  >
                    <i className="bi bi-eye"></i>
                  </button>

                  <button
                    className="icon-btn"
                    onClick={() => moveToWishlist(item)}
                  >
                    <i className="bi bi-heart"></i>
                  </button>

                  <button
                    className="icon-btn"
                    onClick={() => removeItem(item.id)}
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>

          <button className="continue-btn" onClick={() => navigate("/designs")}>
            Continue Shopping
          </button>
        </div>

        {/* RIGHT SIDE */}

        <div className="col-lg-3">
          <div className="order-summary">
            <h4>ORDER SUMMARY</h4>

            <div className="summary-row">
              <span>{cartData.length} DESIGN IN CART</span>
            </div>

            <div className="summary-row">
              <span>Total Order</span>
              <span>Rs. {total}</span>
            </div>

            <button className="send-order" onClick={handleSendOrder}>
              SEND ORDER
            </button>
          </div>
        </div>
      </div>
      <HorizontalAds />
      {previewImage && (
        <div
          className="image-preview-overlay"
          onClick={() => setPreviewImage(null)}
        >
          <div
            className="image-preview-box"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="image-preview-close"
              onClick={() => setPreviewImage(null)}
            >
              <i className="bi bi-x-lg"></i>
            </button>

            <img
              src={previewImage}
              alt="Preview"
              className="image-preview-img"
            />
          </div>
        </div>
      )}
    </div>
  );
}
